<template>
  <div>
    <div v-if="loading" class="overlay">
      <div class="loading-indicator">{{ $t("message.loading") }}</div>
    </div>
    <div class="product-container" @scroll="handleScroll">
      <v-card
        v-for="webshop_product in products"
        :key="webshop_product.id"
        class="product-card"
        height="800"
      >
        <h2 class="product-heading" style="height: 10%">
          {{ webshop_product.display_product_name }}
        </h2>
        <v-img
          class="mx-auto mb-2"
          :src="getImgSrc(webshop_product)"
          alt="product image"
          height="40%"
          contain
        />

        <p class="product-price" style="height: 8%">
          {{ $t("label.price") }}: €
          {{ (webshop_product.product.price_in_cents / 100).toFixed(2) }}
        </p>

        <v-container class="product-information mb-4" style="height: 27%">
          <p class="information-title" style="height: 15%">
            {{ $t("label.product_information") }}
          </p>
          <p
            class="information-description overflow-y-auto custom-scrollbar"
            style="height: 85%"
          >
            {{ webshop_product.product.description }}
          </p>
        </v-container>

        <v-card-actions style="height: 10%">
          <v-col cols="12" class="text-center">
            <v-btn
              @click="openProductModal(webshop_product)"
              large
              color="primary"
              class="white--text display-2"
              style="text-transform: none"
            >
              {{ $t("button.pay") }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </div>
    <WebshopOrderModal
      :webshop_product="this.selectedProduct"
      :authenticated="this.authenticated"
      ref="webshopmodal"
    />
  </div>
</template>

<script>
import WebshopOrderModal from "../../../../nonportal/components/webshop/WebshopOrderModal.vue";

export default {
  name: "ProductGrid",
  components: { WebshopOrderModal },
  props: {
    products: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    authenticated: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selectedProduct: null
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {},
  methods: {
    openProductModal(product) {
      this.selectedProduct = product;
      this.$refs.webshopmodal.showModal();
    },
    handleScroll() {
      const scroll_position = window.innerHeight + window.scrollY;
      const bottom_position = document.documentElement.offsetHeight;

      if (scroll_position + 100 >= bottom_position) {
        this.$emit("loadProducts");
      }
    },
    getImgSrc(webshop_product) {
      if (webshop_product.product.image_url) {
        return (
          this.$store.state.config.imgUrl + webshop_product.product.image_url
        );
      }
      if (this.$store.state.config.webshop_configuration.default_image_url) {
        return (
          this.$store.state.config.imgUrl +
          this.$store.state.config.webshop_configuration.default_image_url
        );
      }
      return null;
    }
  }
};
</script>

<style scoped>
.product-container {
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 1%;
}

.product-card {
  border-radius: 15px;
  margin-bottom: 5%;
}

.product-heading {
  padding: 15px;
}

.product-price {
  background-color: #f0821e;
  color: white;
  font-size: 22px;
  padding: 10px 15px;
  margin-top: 2px;
}

.product-price p {
  margin: 0;
}

.product-information {
  padding: 5px 15px;
  height: 30%;
}

.product-information p:first-child {
  font-size: 22px;
  font-weight: bold;
}

.product-information p:last-child {
  font-size: 18px;
  color: #7d8293;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5); /* semi-transparent background */
  backdrop-filter: blur(5px); /* blur effect */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* Ensure it's above other content */
  pointer-events: none; /* Prevent interaction with elements underneath */
}

.loading-indicator {
  padding: 20px;
  font-size: 18px;
  color: #f0821e;
  background: #ececec;
  border-radius: 5px;
}

.information-title {
  height: 10%;
}

.information-description {
  white-space: pre-line;
}
</style>
